<!-- digiflex.pk -->

(function () {
  'use strict';

  var pageType = document.body.dataset.pageType;
  if (pageType !== 'product' && pageType !== 'collection') return;

  var SESSION_KEY = 'sp_dismissed';

  function isDismissed() {
    return sessionStorage.getItem(SESSION_KEY) === '1';
  }

  function dismissForSession() {
    sessionStorage.setItem(SESSION_KEY, '1');
  }

  if (isDismissed()) return;

  var CONFIG = {
    firstDelay: 8000,
    interval: 10000,
    displayDuration: 4000,
  };

  var NAMES = [
    'Ayesha','Fatima','Sana','Zainab','Hina','Maryam','Nadia','Sara','Amna','Rida',
    'Saba','Rabia','Noor','Maham','Iqra','Layla','Mehwish','Sadia','Uzma','Aliza',
    'Kiran','Sumera','Amber','Farah','Naila','Bushra','Shazia','Tahira','Rukhsar','Fiza',
    'Nimra','Areeba','Hoorain','Misbah','Sidra','Saima','Lubna','Shabnam','Dur-e-Nayab','Anum',
    'Shumaila','Komal','Anam','Muskan','Zara','Aisha','Hafsa','Umme Habiba','Ramsha','Tooba',
    'Sundas','Huma','Wajeeha','Javeria','Muqaddas','Laraib','Anmol','Maheen','Sehrish',
    'Roohi','Nazish','Gulnaz','Parveen','Shaheen','Nafeesa','Shamsa','Zubaida','Dilnoza','Arfa',
    'Zoya','Maha','Isha','Dua','Amal','Sobia','Tehreem','Nayab','Hajra','Kinza',
    'Momina','Rimsha','Fariha','Shagufta','Razia','Nargis','Shamim','Rehana','Nasreen','Perveen',
    'Abida','Saira','Rufia','Humera','Nosheen','Samina','Tabassum','Fauzia','Ghazala','Asma',
    'Mahnoor','Eshal','Aiman','Wishah','Khadija','Asra','Mahira','Areesha','Rabeea','Maliha',
    'Sehar','Anaya','Hira','Sumaiya','Mariam','Quratulain','Faryal','Mavra','Aroosa','Wardah',
    'Eman','Hadiya','Mehak','Yusra','Bisma','Aleena','Ifrah','Tania','Iram','Ushna',
    'Zoha','Aiza','Sania','Marwa','Madiha','Saliha','Afsheen','Zarish','Minahil',
    'Habiba','Soha','Khansa','Mahjabeen','Rakhshanda','Nigar','Saadia','Farkhanda','Shaista','Lubaina',
    'Nazia','Sajida','Tehmina','Yumna','Areej','Najia','Sabahat','Farzana','Khushbakht',
    'Anosha','Maira','Esha','Alishba','Wajiha','Sumbal',
    'Mehreen','Zonaira','Sundus','Falak','Mehlab','Tazeen',
    'Adeena','Noreen','Anila','Ramla','Yashfa','Kainat',
    'Usman','Ali','Hassan','Ahmed','Bilal','Hamza','Tariq','Imran','Faisal','Arslan'
];

  var CITIES = [
    'Lahore','Karachi','Islamabad','Rawalpindi','Faisalabad','Multan','Peshawar',
    'Quetta','Sialkot','Gujranwala','Hyderabad','Bahawalpur','Sargodha','Sukkur',
    'Larkana','Sheikhupura','Rahim Yar Khan','Mirpur','Abbottabad','Mardan',
    'Gujrat','Kasur','Dera Ghazi Khan','Nawabshah','Mingora','Okara','Sahiwal',
    'Jhang','Chiniot','Muzaffarabad','Attock','Chakwal','Jhelum','Mandi Bahauddin',
    'Hafizabad','Narowal','Khanewal','Pakpattan','Vehari','Lodhran','Bahawalnagar',
    'Mianwali','Bhakkar','Layyah','Muzaffargarh','Rajanpur','Jacobabad','Shikarpur',
    'Kamber','Dadu','Matiari','Tando Allahyar','Tando Muhammad Khan','Badin','Thatta',
    'Mirpurkhas','Umerkot','Sanghar','Khairpur','Ghotki','Kashmore','Kandhkot',
    'Turbat','Khuzdar','Chaman','Zhob','Kharan','Nushki','Panjgur','Hub',
    'Bannu','Kohat','Dera Ismail Khan','Swat','Mingora','Chitral','Dir','Timergara',
    'Haripur','Mansehra','Battagram','Shangla','Buner','Malakand','Nowshera','Charsadda',
    'Wah Cantt','Taxila','Kahuta','Gujar Khan','Murree','Kotli','Bhimber','Rawalakot'
  ];

var ACTIONS = [
  'Purchased'
];

 var TIME_TEXTS = [
  // 0-30 mins (most entries — feels active)
  '2 minutes ago','3 minutes ago','5 minutes ago','7 minutes ago',
  '8 minutes ago','10 minutes ago','12 minutes ago','15 minutes ago',
  '18 minutes ago','20 minutes ago','22 minutes ago','25 minutes ago',
  '28 minutes ago','30 minutes ago',
  // 30-60 mins
  '35 minutes ago','40 minutes ago','45 minutes ago','50 minutes ago',
  '55 minutes ago',
  // 1-2 hours
  '1 hour ago','1 hour 15 mins ago','1 hour 30 mins ago','1 hour 45 mins ago',
  '2 hours ago',
  // 2-6 hours (fewer entries — occasional, not dominant)
  '3 hours ago','4 hours ago','5 hours ago','6 hours ago'
];

  var PRODUCTS = [];
  var collectionHandle = document.body.dataset.collectionHandle;
  var productHandle = document.body.dataset.productHandle;
  var currentURL = '';
  var popup = null;
  var imgEl = null;
  var locationEl = null;
  var actionEl = null;
  var timeEl = null;
  var hideTimer = null;
  var isPaused = false;

  // --- Swipe-to-dismiss state (mobile) ---
  var touchStartY = 0;
  var touchStartX = 0;
  var touchCurrentY = 0;
  var touchCurrentX = 0;
  var isDragging = false;
  var isMobileLayout = false;
  var justSwiped = false;

  // SAME formula as the "X sold in last 24 hours" badge — keeps both in sync
  function seededRand(seed) {
    var s = ((seed % 9999) + 1) * 1103515245 + 12345;
    s = s & 0x7fffffff;
    return s / 0x7fffffff;
  }

  function isZeroCategory(pid, rawTags) {
    var tags = '';
    if (Array.isArray(rawTags)) {
      tags = rawTags.join(',').toLowerCase();
    } else if (typeof rawTags === 'string') {
      tags = rawTags.toLowerCase();
    }
    if (tags.indexOf('bestseller') !== -1) return false;
    var dayKey = Math.floor(Date.now() / (1000 * 60 * 60 * 24));
    var r = seededRand((pid % 9999) + (dayKey % 999));
    return r >= 0.57;
  }

  function fetchProducts() {
    fetch('/products.json?limit=250')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var allProducts = data.products || [];
        var filtered = allProducts.filter(function (p) {
          if (!p.images || p.images.length === 0) return false;
          var tags = Array.isArray(p.tags)
            ? p.tags.join(',').toLowerCase()
            : (p.tags || '').toLowerCase();
          // Skip products whose "sold in last 24h" badge is hidden (zero category)
          return !isZeroCategory(p.id, tags);
        });
        PRODUCTS = filtered.map(function (p) {
          return {
            title: p.title,
            image: p.images[0].src.replace(/(\.[a-z]+)$/, '_100x100$1'),
            url: '/products/' + p.handle,
          };
        });
        if (PRODUCTS.length > 0) startCycle();
      })
      .catch(function (err) { console.warn('Sales popup: products fetch failed', err); });
  }

  function rand(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function showPopup() {
    if (isPaused || isDismissed() || !PRODUCTS.length) return;
    var product = rand(PRODUCTS);
    if (!product || !product.image) return;

    var title = product.title;
    if (title.length > 32) title = title.substring(0, 32) + '\u2026';

    locationEl.textContent = rand(NAMES) + ' in ' + rand(CITIES);
    actionEl.textContent = rand(ACTIONS) + ' ' + title;
    timeEl.textContent = rand(TIME_TEXTS);
    imgEl.src = product.image;
    imgEl.loading = 'lazy';
    currentURL = product.url || '';

    popup.classList.add('sp-show');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      popup.classList.remove('sp-show');
    }, CONFIG.displayDuration);
  }

  function startCycle() {
    if (isDismissed()) return;

    PRODUCTS = PRODUCTS.sort(function () { return Math.random() - 0.5; });
    var shown = 0;
    var maxShows = 2 + Math.floor(Math.random() * 2); // shows 2-3 times per page, then stops

    setTimeout(function () {
      if (isDismissed()) return;
      showPopup();
      var timer = setInterval(function () {
        if (isDismissed()) { clearInterval(timer); return; }
        shown++;
        if (shown >= maxShows) { clearInterval(timer); return; }
        showPopup();
      }, CONFIG.interval + CONFIG.displayDuration);
    }, CONFIG.firstDelay);
  }

  function buildPopup() {
    var style = document.createElement('style');
    style.textContent = [
      '#sp-popup{position:fixed;bottom:20px;left:20px;z-index:99999;background:#fff;border-radius:12px;',
      'box-shadow:0 4px 24px rgba(0,0,0,0.13);width:320px;max-width:calc(100vw - 40px);',
      'display:flex;align-items:stretch;overflow:hidden;transform:translateY(120px);opacity:0;',
      'transition:transform 0.45s cubic-bezier(.22,1,.36,1),opacity 0.45s ease;',
      'pointer-events:none;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;cursor:pointer;}',
      '#sp-popup.sp-show{transform:translateY(0);opacity:1;pointer-events:auto;}',
      '#sp-popup.sp-dragging{transition:none;}',
      '@media(max-width:768px){#sp-popup{bottom:auto;left:50%;top:16px;',
      'transform:translateX(-50%) translateY(-120px);width:90vw;max-width:360px;}',
      '#sp-popup.sp-show{transform:translateX(-50%) translateY(0);}}',
      '#sp-img-wrap{width:82px;min-height:82px;flex-shrink:0;background:#f5f5f5;',
      'display:flex;align-items:center;justify-content:center;overflow:hidden;}',
      '#sp-img-wrap img{width:100%;height:100%;object-fit:cover;}',
      '#sp-body{padding:12px 14px 12px 12px;flex:1;min-width:0;display:flex;',
      'flex-direction:column;justify-content:center;gap:2px;}',
      '#sp-location{font-size:12px;color:#888;font-weight:500;white-space:nowrap;',
      'overflow:hidden;text-overflow:ellipsis;}',
      '#sp-action{font-size:14px;font-weight:700;color:#111;white-space:nowrap;',
      'overflow:hidden;text-overflow:ellipsis;line-height:1.3;}',
      '#sp-time{font-size:12px;color:#aaa;margin-top:4px;}',
      '#sp-close{position:absolute;top:8px;right:10px;background:none;border:none;',
      'cursor:pointer;color:#bbb;font-size:16px;width:22px;height:22px;border-radius:50%;',
      'display:flex;align-items:center;justify-content:center;',
      'transition:background 0.2s,color 0.2s;}',
      '#sp-close:hover{background:#f0f0f0;color:#555;}',
      '#sp-dot{display:inline-block;width:7px;height:7px;border-radius:50%;',
      'background:#2ecc71;margin-right:5px;animation:sp-pulse 1.5s infinite;}',
      '@keyframes sp-pulse{0%,100%{opacity:1}50%{opacity:0.4}}'
    ].join('');
    document.head.appendChild(style);

    var div = document.createElement('div');
    div.id = 'sp-popup';
    div.setAttribute('role', 'alert');
    div.setAttribute('aria-live', 'polite');
    div.innerHTML = [
      '<div id="sp-img-wrap"><img id="sp-product-img" src="" alt="product"></div>',
      '<div id="sp-body">',
      '<div id="sp-location"></div>',
      '<div id="sp-action"></div>',
      '<div id="sp-time"><span id="sp-dot"></span><span id="sp-time-text"></span></div>',
      '</div>',
      '<button id="sp-close" aria-label="Close">&#x2715;</button>'
    ].join('');
    document.body.appendChild(div);

    popup     = div;
    imgEl     = document.getElementById('sp-product-img');
    locationEl = document.getElementById('sp-location');
    actionEl  = document.getElementById('sp-action');
    timeEl    = document.getElementById('sp-time-text');

    var closeBtn = document.getElementById('sp-close');
    popup.addEventListener('click', function (e) {
      if (e.target === closeBtn) return;
      if (justSwiped) { justSwiped = false; return; }
      if (currentURL) window.location.href = currentURL;
    });
    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      popup.classList.remove('sp-show');
      clearTimeout(hideTimer);
      dismissForSession();
    });
    popup.addEventListener('mouseenter', function () { isPaused = true; });
    popup.addEventListener('mouseleave', function () { isPaused = false; });

    // --- Swipe-to-dismiss (touch) ---
    popup.addEventListener('touchstart', onTouchStart, { passive: true });
    popup.addEventListener('touchmove', onTouchMove, { passive: false });
    popup.addEventListener('touchend', onTouchEnd, { passive: true });
  }

  function getIsMobileLayout() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function onTouchStart(e) {
    if (!e.touches || e.touches.length === 0) return;
    isMobileLayout = getIsMobileLayout();
    touchStartY = e.touches[0].clientY;
    touchStartX = e.touches[0].clientX;
    touchCurrentY = touchStartY;
    touchCurrentX = touchStartX;
    isDragging = true;
    isPaused = true; // pause auto-hide timer while user is interacting
    clearTimeout(hideTimer);
    popup.classList.add('sp-dragging');
  }

  function onTouchMove(e) {
    if (!isDragging || !e.touches || e.touches.length === 0) return;
    touchCurrentY = e.touches[0].clientY;
    touchCurrentX = e.touches[0].clientX;

    var deltaY = touchCurrentY - touchStartY;
    var deltaX = touchCurrentX - touchStartX;

    if (isMobileLayout) {
      // Mobile popup sits at the top — only let it follow an UPWARD drag
      // (negative deltaY). Ignore downward drags (would just re-cover itself).
      var dragY = Math.min(0, deltaY);
      // Allow a little horizontal sideways follow too, so a diagonal swipe feels natural
      var dragX = deltaX * 0.3;
      popup.style.transform = 'translateX(calc(-50% + ' + dragX + 'px)) translateY(' + dragY + 'px)';
      popup.style.opacity = String(Math.max(0.15, 1 - Math.abs(dragY) / 150));
    } else {
      // Desktop popup sits at bottom-left — let it follow sideways or downward drag
      var dx = Math.max(0, deltaX); // only rightward (away from screen edge) or...
      var dy = Math.max(0, deltaY); // ...downward feels natural for a bottom-left toast
      var dist = Math.max(dx, dy);
      popup.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
      popup.style.opacity = String(Math.max(0.15, 1 - dist / 150));
    }

    // Prevent the page from scrolling while actively dragging the popup
    e.preventDefault();
  }

  function onTouchEnd() {
    if (!isDragging) return;
    isDragging = false;
    popup.classList.remove('sp-dragging');

    var deltaY = touchCurrentY - touchStartY;
    var deltaX = touchCurrentX - touchStartX;
    var DISMISS_THRESHOLD = 60;

    var shouldDismiss = isMobileLayout
      ? (-deltaY > DISMISS_THRESHOLD) // swiped up far enough
      : (deltaX > DISMISS_THRESHOLD || deltaY > DISMISS_THRESHOLD); // swiped away far enough

    // Clear the inline transform/opacity we set during drag so CSS classes take back over
    popup.style.transform = '';
    popup.style.opacity = '';

    if (shouldDismiss) {
      popup.classList.remove('sp-show');
      isPaused = false;
      justSwiped = true;
      dismissForSession();
    } else {
      // Snap back to visible position; resume the normal auto-hide countdown
      isPaused = false;
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        popup.classList.remove('sp-show');
      }, CONFIG.displayDuration);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      buildPopup();
      setTimeout(fetchProducts, 4000);
    });
  } else {
    buildPopup();
    setTimeout(fetchProducts, 4000);
  }

})();